import React, { Component, Suspense } from "react";
import { Col, Row } from "reactstrap";
import ContentWrapper from "./../../../template/Layout/ContentWrapper";
import { Tab } from "semantic-ui-react";
import Documents from "../../Components/Documents";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import axios from "axios";
import _ from "lodash";
import { Services } from "../../../../repositories/clients/Services";
import MpaJson from "../../../../models/mapJson.js";
import Loader from "../../../Global/Loader";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import RepositoryFactory from "../../../../repositories/RepositoryFactory";
import { validateIdParams } from "../../../utils/regularExpressionValidation.js";
import { openNotification } from "../../Components/Notification/index.js";

const Events = React.lazy(() => import("./Events"));
const SumaryDetail = React.lazy(() => import("./Sumary/SumaryDetail"));
const Comments = React.lazy(() => import("../../Components/Comments"));
const AllComments = React.lazy(
  () => import("../../Components/Comments/AllComment"),
);
const HashTable = require("../../Components/utils/HashTable");
const PurchaseOrderClient = RepositoryFactory.get("PurchaseOrder");

class ShipmentDetail extends Component {
  state = {
    token: this.props.token,
    isMobil: false,
    scrollLine: true,
    tabActive: 0,
    fullLoader: false,
    markers: [],
    Resumen: [],
    polylineData: [],
    dataMap: [],
    id: this.props.match.params.id,
    rolId: this.props._rolId,
    userId: this.props._user,
    allSteps: [],
    documentos: [],
    AllcommentsData: [
      {
        id: 1,
        title: this.props.t("request"),
        data: [
          {
            expanded: false,
            id: "TP-SEA-2022-0025",
            message: [],
          },
          {
            expanded: false,
            id: "TP-SEA-2022-234",
            message: [
              // {
              //   Color: 1,
              //   Comment: "tester plan de transporte ",
              //   CommentId: 59,
              //   CreationDate: "31-08-2022 10:20:20 AM",
              //   Deleted: "0",
              //   DeletedDate: null,
              //   Important: "0",
              //   Module: "Shipment",
              //   ModuleId: 3,
              //   RolId: 1,
              //   Role: "Administrador",
              //   RowId: 336,
              //   User: "Info Info",
              //   UserId: 1,
              // },
            ],
          },
        ],
      },
      {
        id: 2,
        title: this.props.t("transport_plan"),
        data: [
          {
            expanded: false,
            id: "EP/COA/AI/S0025",
            message: [
              // {
              //   Color: 1,
              //   Comment: "tester plan de transporte ",
              //   CommentId: 59,
              //   CreationDate: "31-08-2022 10:20:20 AM",
              //   Deleted: "0",
              //   DeletedDate: null,
              //   Important: "0",
              //   Module: "Shipment",
              //   ModuleId: 3,
              //   RolId: 1,
              //   Role: "Administrador",
              //   RowId: 336,
              //   User: "Info Info",
              //   UserId: 1,
              // },
            ],
          },
        ],
      },
    ],
    commentsData: [],
    users: [],
    tables: [],
    baseTables: {
      routes: {
        key: "Rutas",
        title: this.props.t("transshipment"),
        columns: [
          {
            label: this.props.t("secuence"),
            key: "LegNumber",
            minWidth: 70,
            maxWidth: 70,
          },
          {
            label: this.props.t("location"),
            key: "Country",
            minWidth: 250,
            maxWidth: 250,
          },
          {
            label: this.props.t("trip_flight"),
            key: "Voyage_FlightNo",
            minWidth: 250,
            maxWidth: 250,
          },
          {
            label: this.props.t("carrier"),
            key: "Carrier",
            minWidth: 250,
            maxWidth: 250,
          },
          { label: this.props.t("vessel"), key: "Vessel" },
          { label: this.props.t("transport_mode"), key: "TransportMode" },
          { label: this.props.t("atd"), key: "ATD" },
          { label: this.props.t("ata"), key: "ATA" },
          { label: this.props.t("etd"), key: "ETD" },
          { label: this.props.t("eta"), key: "ETA" },
        ],
      },

      so: {
        key: "SO",
        title: this.props.t("order_ref"),
        columns: [
          {
            label: this.props.t("number"),
            key: "OrderId",
            minWidth: 250,
            maxWidth: 250,
            custom: (value) => (
              <Link
                // style={{ color: "#0561FC", fontWeight: "bold" }}
                className="link-euro"
                to={"/so-detail-view/" + value.ServiceOrderId}
              >
                {value.RefCustomer}
              </Link>
            ),
          },
          { label: this.props.t("shipper"), key: "SupplierName" },
          { label: this.props.t("consignee"), key: "ConsigneeName" },
          {
            label: this.props.t("must_arrive_date"),
            key: "RequiredDateDestination",
          },
        ],
      },

      packages: {
        key: "Containers",
        title: this.props.t("packages"),
        columns: [
          {
            label: this.props.t("line"),
            key: "LineContainer",
          },
          {
            label: this.props.t("total_packages"),
            key: "Packages",
          },
          {
            label: this.props.t("total_píeces"),
            key: "Pieces",
          },
          {
            label: this.props.t("package_type"),
            key: "Measure",
          },
          {
            label: this.props.t("chargable_weight"),
            key: "UOMWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("gross_weight"),
            key: "UOMGrossWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("total_volume"),
            key: "UOMVolumeDescription",
            format: "dimension",
          },
          {
            label: this.props.t("dimensions"),
            key: "UOMDimensionsDescription",
            format: "dimension",
          },
          {
            label: this.props.t("goods_description"),
            key: "GoodsDescription",
            minWidth: 250,
            maxWidth: 250,
          },
        ],
      },

      emissions: {
        key: "EmissionsC02",
        title: this.props.t("emissions_co2"),
        columns: [
          {
            label: this.props.t("total_co2_generated"),
            key: "CO2",
            format: "weight",
          },
          {
            label: this.props.t("traveled_kilometers"),
            key: "Distance",
            format: "dimension",
          },
          { label: this.props.t("average_co2"), key: "Average" },
        ],
      },
    },

    seaFCLOverrides: {
      containers: {
        key: "Containers",
        title: this.props.t("containers"),
        columns: [
          {
            label: this.props.t("contianer_num"),
            key: "ContainerNo",
            minWidth: 250,
            maxWidth: 250,
            custom: (value) => (
              <Link
                className="link-euro"
                to={"/container-detail-components/" + value.ContainerId}
              >
                {value.ContainerNo}
              </Link>
            ),
          },
          {
            label: this.props.t("status"),
            key: "Status",
            minWidth: 150,
            custom: (value) =>
              value.Status ? (
                <span class="badge badge-euro">{value.Status}</span>
              ) : null,
          },
          { label: this.props.t("container_type"), key: "ContainerType" },
          { label: this.props.t("seal"), key: "Seal" },
          { label: this.props.t("required_temperature"), key: "Temperature" },
          { label: this.props.t("total_packages"), key: "Packages" },
          { label: this.props.t("total_píeces"), key: "Pieces" },
          {
            label: this.props.t("chargable_weight"),
            key: "UOMWeightDescription",
            format: "weight",

          },
          { label: this.props.t("total_volume"), key: "UOMVolumeDescription" },
          {
            label: this.props.t("dimensions"),
            key: "UOMDimensionsDescription",
          },
        ],
      },
    },

    airHouseOverrides: {
      waybill: {
        key: "Waybill",
        title: this.props.t("house_air_way"),
        columnsTable: [
          {
            label: "",
            key: "",
            CollapseTable: true,
            flatColor: true,
            keydatavalidate: "Status",
            minWidth: 50,
            maxWidth: 50,
          },
          { label: "HAWB", key: "HouseReference" },
          { label: this.props.t("orders_reference"), key: "RefCustomer" },
          { label: this.props.t("shipper"), key: "NameShipper" },
          { label: this.props.t("pickup_address"), key: "PickupLocation" },
          { label: this.props.t("pickup_date"), key: "LinePickupDate" },
          { label: this.props.t("consignee"), key: "NameConsignee" },
          { label: this.props.t("delivery_address"), key: "DeliveryLocation" },
          { label: this.props.t("delivery_date"), key: "LineDeliveryDate" },
        ],
        subTable: [
          { label: this.props.t("line"), key: "LineHouse" },
          { label: this.props.t("packages"), key: "Packages" },
          { label: this.props.t("pieces"), key: "Pieces" },
          { label: this.props.t("package_type"), key: "Measure" },
          {
            label: this.props.t("weight"),
            key: "UOMWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("gross_weight"),
            key: "UOMGrossWeightDescription",
            format: "weight",
          },
          {
            label: this.props.t("volume"),
            key: "UOMVolumeDescription",
            format: "dimension",
          },
          {
            label: this.props.t("dimensions"),
            key: "UOMDimensionsDescription",
            format: "dimension",
          },
          {
            label: this.props.t("shipment_descriptions"),
            key: "GoodsDescription",
            minWidth: 250,
          },
        ],
        subHeader: (
          <>
            <th>{this.props.t("line")}</th>
            <th>{this.props.t("packages")}</th>
            <th>{this.props.t("pieces")}</th>
            <th>{this.props.t("package_type")}</th>
            <th>{this.props.t("weight")}</th>
            <th>{this.props.t("gross_weight")}</th>
            <th>{this.props.t("volume")}</th>
            <th>{this.props.t("dimensions")}</th>
            <th>{this.props.t("shipment_descriptions")}</th>
          </>
        ),
      },
    },
  };

  componentDidMount = async () => {
    const idValidate = validateIdParams(this.props.match.params.id);
    if (!idValidate) {
      openNotification("error", this.props.t("Data_entered_is_invalid"));
      setTimeout(() => {
        this.props.history.push("/shipment-visibility");
      }, 2000);
      return;
    }

    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    console.log("isMobileDevice-->", isMobileDevice);
    this.setState({
      isMobil: isMobileDevice,
    });

    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }
    this.getShipmentsForId(notifyActiveComment);
    this.getCommets(false);
  };

  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }

    const newProp = nextProps.match.params.id
      ? nextProps.match.params.id
      : this.props.match.params.id;
    this.setState({ id: newProp, fullLoader: false }, () => {
      this.getShipmentsForId(notifyActiveComment);
      this.getCommets(true);
    });
  };

  getCommets = (noscroll, messageSucces) => {
    const { id } = this.state;
    let moduleId = 3;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/get-comment?rowid=${id}&moduleid=${moduleId}&general=true&zona=${timezone}&lang=${this.props.lng}`,
      )
      .then((response) => {
        let comentario = response.data.Comment;
        let AllcommentsData = response.data.CommentGeneral;
        this.setState(
          { commentsData: comentario, AllcommentsData, scrollLine: noscroll },
          () => {
            if (messageSucces) {
              openNotification("success", messageSucces);
            }
          },
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  setNewDocs = (docs) => {
    this.setState({
      documentos: docs,
    });
  };

  getEvents = (notifyActiveComment, tab) => {
    const { id } = this.state;
    let moduleId = 3;
    axios
      .get(
        `${Services.TRACEABILITY.path}trazabilidad/shipmentevents/${id}?lang=${this.props.lng}`,
      )
      .then((response) => {
        let dataEvents = response.data.data;
        let newSteps = response.data.steps;
        this.setState(
          {
            steps: newSteps,
            allSteps: dataEvents,
            fullLoader: true,
            tabActive: notifyActiveComment ? 2 : 0,
          },
          () => {},
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleBack = () => {};

  validarRail = (resumeModel, info) => {
    const allowedServiceTypes = ["Import", "Export", "Crosstrade"];
    const allowedShipmentTypes = ["FTL", "LTL"];

    const shouldShowBorderFields =
      allowedServiceTypes.includes(info.ServiceType) &&
      allowedShipmentTypes.includes(info.ShipmentType);

    if (!shouldShowBorderFields) {
      const fieldsToRemove = [
        "ArrivalBorderDate",
        "ArrivalCustomsDate",
        "BorderDepartureDate",
      ];

      if (resumeModel[1] && Array.isArray(resumeModel[1].data)) {
        resumeModel[1].data = resumeModel[1].data.filter(
          (item) => !fieldsToRemove.includes(item.key),
        );
      }
    }

    const allowedShipmentTypesForContainers = ["FCL", "LCL"];
    const shouldShowContainerFields =
      allowedShipmentTypesForContainers.includes(info.ShipmentType);

    if (!shouldShowContainerFields) {
      const containerFieldsToRemove = [
        "MBL_AWB_PRO",
        "Vessel",
        "TotalContainers",
        "TotalTEUS",
      ];

      if (resumeModel[2] && Array.isArray(resumeModel[2].data)) {
        resumeModel[2].data = resumeModel[2].data.filter(
          (item) => !containerFieldsToRemove.includes(item.key),
        );
      }

      if (resumeModel[3] && Array.isArray(resumeModel[3].data)) {
        resumeModel[3].data = resumeModel[3].data.filter(
          (item) => !containerFieldsToRemove.includes(item.key),
        );
      }
    }

    return resumeModel;
  };

  getTablesByTransport = ({ mode, shipmentType, isHouseAir }) => {
    let { baseTables, seaFCLOverrides, airHouseOverrides } = this.state;

    // const routesTable = JSON.parse(JSON.stringify(baseTables.routes));

    // const map = {
    //   Road: this.props.t("truck_num"),
    //   Air: this.props.t("flight_no"),
    //   Sea: this.props.t("voyage"),
    //   Rail: this.props.t("shipmen_detail_summary_general_train_no"),
    // };
    // const dynamicLabel = map[mode] || this.props.t("trip_flight");

    // routesTable.columns = routesTable.columns.map((col) => {
    //   if (col.key === "Voyage_FlightNo") {
    //     return { ...col, label: dynamicLabel };
    //   }
    //   return col;
    // });

    // let tables = [routesTable, baseTables.so];
    let tables = [baseTables.so, baseTables.routes];

    if (mode === "Sea" && shipmentType === "FCL") {
      tables.push(seaFCLOverrides.containers);
    } else if (isHouseAir) {
      tables.push(airHouseOverrides.waybill);
    } else if (mode === "Rail") {
      if (shipmentType === "FCL") {
        tables.push(seaFCLOverrides.containers);
      } else if (["LCL", "FTL", "LTL"].includes(shipmentType)) {
        tables.push(baseTables.packages);
      }
    } else {
      tables.push(baseTables.packages);
    }

    tables.push(baseTables.emissions);

    return tables;
  };

  getShipmentsForId = async (notifyActiveComment) => {
    try {
      const { _user, lng } = this.props;

      const urlDataShipment = `${Services.TRACEABILITY.path}trazabilidad/dataShipments/${this.state.id}?user=${_user}&lang=${lng}`;
      const requestGetPO = {
        userId: _user,
        limit: 10,
        pag: 1,
        shipmentId: this.state.id,
        lang: lng,
      };
      const [response, POs] = await Promise.all([
        axios.get(urlDataShipment),
        PurchaseOrderClient.getOrdersByShipment(requestGetPO),
      ]);

      const data = response.data.data;

      let body = {
        code: data.infoEmbarque.ShipmentCode,
        instance: data.infoEmbarque.Instance,
        shipmentId: data.infoEmbarque.ShipmentId,
      };
      // LIMITAR DOCUMENTOS POR ROL
      const Documents = await PurchaseOrderClient.getDocuments(body);

      const markers = [];
      const polylineData = [];

      const addMarker = (key, title, lat, lng) => {
        if (lat && lng) {
          markers.push({
            anchorX: 0,
            anchorY: 0,
            key,
            title,
            data: data.infoEmbarque,
            position: { lat, lng },
            icon: {
              url:
                data.infoEmbarque.TCC === "1"
                  ? "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapaTCC.png"
                  : "https://magiclog.blob.core.windows.net/europartnerspic/tracking-mapa.png",
            },
          });
          const position = { lat: Number(lat), lng: Number(lng) };
          polylineData.push(position);
        }
      };

      addMarker(
        1,
        this.props.t("origin"),
        data.infoEmbarque.POLLatitude,
        data.infoEmbarque.POLLongitude,
      );
      addMarker(
        2,
        this.props.t("destination"),
        data.infoEmbarque.PODLatitude,
        data.infoEmbarque.PODLongitude,
      );

      const transportTemplates = {
        1: MpaJson.cardResumenMaritimo,
        2: MpaJson.cardResumenAereo,
        3: MpaJson.cardResumenTerrestre,
        4: MpaJson.cardResumenRail,
      };

      const resumeModel = _.cloneDeep(
        transportTemplates[data.infoEmbarque.TransportModeCode] ||
          MpaJson.cardResumenTerrestre,
      );

      if (data.infoEmbarque.TransportModeCode === 4) {
        this.validarRail(resumeModel, data.infoEmbarque);
      }

      const newResume = resumeModel.map((f) => {
        f.data.forEach((g) => {
          if (g.infoTool) {
            g.arrayInfoTool.forEach((aif) => {
              aif.value = data.infoEmbarque[aif.key];
            });
          }

          g.value = data.infoEmbarque[g.key];
          g.value2 = data.infoEmbarque[g.key2];

          if (f.infoTool) {
            f.arrayInfoTool.forEach((aif) => {
              aif.value = data.infoEmbarque[aif.key];
            });
          }
        });

        return f;
      });

      const isHouseAir =
        data.infoEmbarque.TransportMode === "Air" &&
        data.infoEmbarque.ServiceType === "Export";

      if (isHouseAir) {
        const containers = data.Containers || [];
        const Table = new HashTable();

        containers.forEach((dataWaybill) => {
          if (Table.exist(dataWaybill.HouseReference)) {
            const Factura = Table.getElement(dataWaybill.HouseReference);
            Factura.sub.push({
              Packages: dataWaybill.Packages,
              Pieces: dataWaybill.Pieces,
              Measure: dataWaybill.Measure,
              UOMWeightDescription: dataWaybill.UOMWeightDescription,
              UOMGrossWeightDescription: dataWaybill.UOMGrossWeightDescription,
              UOMVolumeDescription: dataWaybill.UOMVolumeDescription,
              UOMDimensionsDescription: dataWaybill.UOMDimensionsDescription,
              LineHouse: dataWaybill.LineHouse,
              GoodsDescription: dataWaybill.GoodsDescription,
            });
            Table.updateElement(dataWaybill.HouseReference, Factura);
          } else {
            Table.addElement(dataWaybill.HouseReference, {
              ...dataWaybill,
              sub: [
                {
                  Packages: dataWaybill.Packages,
                  Pieces: dataWaybill.Pieces,
                  Measure: dataWaybill.Measure,
                  UOMWeightDescription: dataWaybill.UOMWeightDescription,
                  UOMGrossWeightDescription:
                    dataWaybill.UOMGrossWeightDescription,
                  UOMVolumeDescription: dataWaybill.UOMVolumeDescription,
                  UOMDimensionsDescription:
                    dataWaybill.UOMDimensionsDescription,
                  LineHouse: dataWaybill.LineHouse,
                  GoodsDescription: dataWaybill.GoodsDescription,
                },
              ],
            });
          }
        });

        data.Waybill = Table.elements();
      }

      /**
       * Revision de tablas a mostrar, dependiendo el tipo de transporte y embarque
       * 1 Sea
       * 2 Air
       * 3 Road
       */
      const netTabla = this.getTablesByTransport({
        mode: data.infoEmbarque.TransportMode,
        shipmentType: data.infoEmbarque.ShipmentType,
        isHouseAir,
      });

      netTabla.forEach((f) => {
        let defaultData = [{}];
        if (f.key === "EmissionsC02") {
          let co2 = "";
          let distance = "";
          let average = "";
          if (data.infoEmbarque && data.infoEmbarque.CO2) {
            co2 = data.infoEmbarque.CO2;
          }
          if (data.infoEmbarque && data.infoEmbarque.Distance) {
            distance = data.infoEmbarque.Distance;
          }
          if (data.infoEmbarque && data.infoEmbarque.Average) {
            average = data.infoEmbarque.Average;
          }
          defaultData = [
            {
              CO2: co2,
              Distance: distance,
              Average: average,
            },
          ];
        } else if (data[f.key] && data[f.key].length > 0) {
          defaultData = data[f.key];
        }
        f.data = defaultData;
      });
      const findSOTable = netTabla.find((f) => f.key === "SO");
      if (!findSOTable.data || !findSOTable.data.length) {
        netTabla.splice(netTabla.indexOf(findSOTable), 1);
      } else if (
        findSOTable.data.length === 1 &&
        Object.keys(findSOTable.data[0]).length === 0
      ) {
        netTabla.splice(netTabla.indexOf(findSOTable), 1);
      }

      if (POs?.data.length) {
        let POTable = {
          columns: [
            {
              label: "",
              key: "",
              CollapseTable: true,
              flatColor: true,
              keydatavalidate: "Status",
              minWidth: 50,
              maxWidth: 50,
            },
            {
              label: this.props.t("po_no"),
              key: "PONumber",
              minWidth: 150,
              maxWidth: 200,
              custom: (value) => (
                <Col md={12} xl={12}>
                  <Row>
                    <Col md={12}>
                      <Link
                        className="link-euro"
                        to={"/po-detail-view/" + value.POId}
                      >
                        {value.PONumber}
                      </Link>
                      {/* <Link className='link-euro' to="#">{value.RefCustomer}</Link> */}
                    </Col>
                  </Row>
                </Col>
              ),
            },
            {
              label: this.props.t("status"),
              key: "StatusPo",
              minWidth: 150,
              maxWidth: 200,
              custom: (value) => (
                <span class="badge badge-euro">{value.StatusPo}</span>
              ),
            },
            {
              label: this.props.t("company"),
              key: "CustomerName",
              minWidth: 200,
            },
            {
              label: this.props.t("shipper"),
              key: "SupplierName",
              minWidth: 200,
            },
            {
              label: this.props.t("consignee"),
              key: "ConsigneeName",
              minWidth: 200,
            },
            {
              label: this.props.t("transport_mode"),
              key: "TransportMode",
              minWidth: 180,
            },
            {
              label: this.props.t("required_at_destination"),
              key: "requireddestinationdate",
              minWidth: 180,
            },
            {
              label: this.props.t("creation"),
              key: "createdate",
              minWidth: 150,
            },
          ],
          subTable: [
            { label: this.props.t("item_line"), key: "LineNo", minWidth: 120 },
            { label: this.props.t("item_no"), key: "ItemNo", minWidth: 120 },
            {
              label: this.props.t("item_description"),
              key: "Description",
              minWidth: 250,
              limitString: 50,
            },
            {
              label: this.props.t("status"),
              key: "Status",
              minWidth: 150,
              maxWidth: 200,
              custom: (value) => (
                <span class="badge badge-euro">{value.Status}</span>
              ),
            },
            {
              label: this.props.t("item_qty_ordered"),
              key: "QTYOrdered",
              minWidth: 120,
            },
            {
              label: this.props.t("item_qty_confirmed"),
              key: "QTYConfirmed",
              minWidth: 120,
            },
            {
              label: this.props.t("item_request_charge"),
              key: "RequiredCagoReady",
              minWidth: 200,
            },
            {
              label: this.props.t("item_promised_charge"),
              key: "PromiseCargoReady",
              minWidth: 200,
            },
            {
              label: this.props.t("item_real_charge"),
              key: "ActualCargoReady",
              minWidth: 150,
            },
          ],
          subHeader: (
            <>
              <th>{this.props.t("item_line")}</th>
              <th>{this.props.t("item_no")}</th>
              <th>{this.props.t("item_description")}</th>
              <th>{this.props.t("status")}</th>
              <th>{this.props.t("item_qty_ordered")}</th>
              <th>{this.props.t("item_qty_confirmed")}</th>
              <th>{this.props.t("item_request_charge")}</th>
              <th>{this.props.t("item_promised_charge")}</th>
              <th>{this.props.t("item_real_charge")}</th>
            </>
          ),
          data: POs.data,
          title: this.props.t("purchase_order"),
          key: "PO",
        };
        POTable.columnsTable = POTable.columns;
        netTabla.splice(0, 0, POTable);
      }
      this.setState(
        {
          markers,
          dataMap: polylineData,
          polylineData,
          Resumen: newResume,
          tables: netTabla,
          users: data.users,
          documentos: Documents.data || [],
          shipment: data.infoEmbarque,
          DoEmbarque: data.infoEmbarque ? data.infoEmbarque.DoEmbarque : "",
          ModoTransporte: data.infoEmbarque
            ? data.infoEmbarque.ModoTransporte
            : "",
          cliente: data.infoEmbarque ? data.infoEmbarque.Cliente : "",
        },
        () => {
          this.getEvents(notifyActiveComment);
        },
      );
    } catch (error) {
      openNotification("error", this.props.t("Data_entered_is_invalid"));
      setTimeout(() => {
        this.props.history.push("/dashboard");
      }, 2000);
      console.warn(error);
    }
  };

  newMessage = async (data) => {
    let { id, userId } = this.state;
    data.Rowid = id;
    data.UserId = userId;
    data.ModuleId = 3;

    console.log("data", data);

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.TRACEABILITY.path}trazabilidad/add-comment`, data)
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_saved"));
      })
      .catch((error) => {
        console.log(error);
        openNotification("error", "Error al mandar el comentario");
      });
  };

  deleteMessage = async (idDelete, toggle) => {
    axios
      .delete(
        `${Services.TRACEABILITY.path}trazabilidad/delete-comment/${idDelete}`,
      )
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_deleted"));
        toggle();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    let logoUrl =
      this.state.ModoTransporte === "Air"
        ? "https://magiclog.blob.core.windows.net/europartnerspic/Icono-aereo.svg"
        : this.state.ModoTransporte === "Road"
          ? "https://magiclog.blob.core.windows.net/europartnerspic/Icono_maritimo.svg"
          : "https://magiclog.blob.core.windows.net/europartnerspic/Icono_terrestre.svg";
    let {
      markers,
      polylineData,
      Resumen,
      tables,
      shipment,
      fullLoader,
      commentsData,
      AllcommentsData,
      users,
      rolId,
      userId,
      tabActive,
      isMobil,
      token,
    } = this.state;

    return (
      <>
        <Loader hidden={fullLoader} />
        <ContentWrapper>
          <div className="content-heading">
            <span className="icon-shipments-visibility icon-header" />
            {this.props.t("shipmentsVisibility")}
            <div className="euro-return-tittle">
              <Icon.Group size="large">
                <Icon
                  name="angle left"
                  className="_btnBack"
                  size="big"
                  onClick={() =>
                    this.props.history.push("/shipment-visibility")
                  }
                />
              </Icon.Group>
              <span
                className="label-back"
                onClick={() => this.props.history.push("/shipment-visibility")}
              >
                {this.props.t("back")}
              </span>
            </div>
          </div>
          <Tab
            menu={{
              secondary: true,
              pointing: true,
              className: "custom-tab-menu",
            }}
            onTabChange={(event, data) => {
              this.setState({ tabActive: data.activeIndex });
            }}
            activeIndex={tabActive}
            panes={[
              {
                menuItem: this.props.t("summary"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <SumaryDetail
                      markers={markers}
                      dataMap={polylineData}
                      polylineData={polylineData}
                      Resumen={Resumen}
                      tables={tables}
                      shipment={shipment}
                      steps={this.state.steps}
                      rolId={rolId}
                      userId={userId}
                      token={token}
                    />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("events"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <Events
                      cliente={this.state.cliente}
                      NIT={this.state.NIT}
                      Grupo={this.state.Grupo}
                      logoUrl={logoUrl}
                      DoEmbarque={this.state.DoEmbarque}
                      HBL_HAWB={this.state.HBL_HAWB}
                      Estatus={this.state.Estatus}
                      allSteps={this.state.allSteps}
                      steps={this.state.steps}
                    />{" "}
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("comments"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <div class="row">
                      <div class="col-xs-12 col-md-6 col-lg-6">
                        <legend className="legendEuroBold">
                          {shipment.ShipmentNumber
                            ? shipment.ShipmentNumber
                            : ""}
                        </legend>
                        <Comments
                          rolId={rolId}
                          userId={userId}
                          data={commentsData}
                          catalogs={users}
                          scrollLine={this.state.scrollLine}
                          funtionNewMessage={this.newMessage}
                          funtionDeleteMessage={this.deleteMessage}
                        />
                      </div>
                      <div class="col-xs-12 col-md-6 col-lg-6">
                        <legend className="legendEuroBold">
                          {this.props.t("related_comments")}
                        </legend>

                        <AllComments data={AllcommentsData} />
                      </div>
                    </div>
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("documents"),
                render: () => (
                  // <div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <div
                      className="content-wrapper"
                      style={{ paddingRight: "0", paddingLeft: "0" }}
                    >
                      <Documents
                        dataDoc={this.state.documentos}
                        rolId={rolId}
                        shipment={shipment}
                        shipmentDataPlane=""
                        isMobil={isMobil}
                        _user={this.props._user}
                        setNewDocs={this.setNewDocs}
                      />
                    </div>
                  </Suspense>
                ),
              },
            ]}
          />
        </ContentWrapper>
      </>
    );
  }
}
export default withNamespaces()(withRouter(ShipmentDetail));
